export default __webpack_public_path__ + "17dd4b3145d6768057792bad89408ea5.png";